// Code for the register component
import React, { useState } from 'react';
import { useAuth, RegisterData } from '../../utils/context/AuthContext';
import { useNavigate, Link } from 'react-router';
const logo = require('../../assets/images/adaptive-icon.png');

const Register = () => {
  const [userData, setUserData] = useState<RegisterData>({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
  });
  const { registerAccount } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const registeredUserData = await registerAccount({ registerData: userData });
    if (registeredUserData && registeredUserData.uid) {
      console.log('User registered successfully');
      navigate('/');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center bg-lightGray h-full w-full gap-4">
      <div>
        <img src={logo} alt="login" className="w-36 h-36" />
        <p className="text-todoister font-boldItalic text-2xl">TODOISTER</p>
      </div>
      <form
        className="w-80 bg-darkGray p-6 rounded-lg shadow-lg justify-center items-center flex flex-col "
        onSubmit={handleSubmit}
      >
        <div className="mb-4 w-full">
          <label htmlFor="email" className="block text-sm font-semiBold text-white">
            Email
          </label>
          <input
            type="email"
            id="email"
            className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-orange focus:border-orange"
            value={userData.email}
            onChange={(e) => setUserData({ ...userData, email: e.target.value })}
          />
        </div>
        <div className="mb-4 w-full">
          <label htmlFor="firstName" className="block text-sm font-semiBold text-white">
            First Name
          </label>
          <input
            type="text"
            id="firstName"
            className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-orange focus:border-orange"
            value={userData.firstName}
            onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
          />
        </div>
        <div className="mb-4 w-full">
          <label htmlFor="lastName" className="block text-sm font-semiBold text-white">
            Last Name
          </label>
          <input
            type="text"
            id="lastName"
            className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-orange focus:border-orange"
            value={userData.lastName}
            onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
          />
        </div>
        <div className="mb-4 w-full">
          <label htmlFor="password" className="block text-sm font-semiBold text-white">
            Password
          </label>
          <input
            type="password"
            id="password"
            className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-orange focus:border-orange"
            value={userData.password}
            onChange={(e) => setUserData({ ...userData, password: e.target.value })}
          />
        </div>
        <div className="mb-4 w-full">
          <label htmlFor="confirmPassword" className="block text-sm font-semiBold text-white">
            Confirm Password
          </label>
          <input
            type="password"
            id="confirmPassword"
            className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-orange focus:border-orange"
          />
        </div>
        <button
          type="submit"
          className=" text-white bg-todoister font-semiBoldItalic w-1/2 py-2 px-4 rounded  hover:bg-todoister-dark"
        >
          Register
        </button>
      </form>
      <div className="text-white font-regular">
        Already have an account?{' '}
        <Link to="/login" className="text-todoister font-boldItalic text-todoister-dark">
          Login
        </Link>
      </div>
    </div>
  );
};

export default Register;
